'use client';

import { useState } from 'react';
import Hero from './components/Hero';
import Story from './components/Story';
import McpExplainer from './components/McpExplainer';
import FounderMessage from './components/FounderMessage';
import Disclaimer from './components/Disclaimer';
import StartChatCta from './components/StartChatCta';
import PrivacyPolicyModal from './components/PrivacyPolicyModal';

export default function LandingPage() {
  const [policyOpen, setPolicyOpen] = useState(false);

  const handleAgree = () => {
    try {
      localStorage.setItem('privacyAgreed', 'true');
    } catch {}
    setPolicyOpen(false);
  };

  return (
    <div className="font-sans">
      <Hero />
      <Story />
      <McpExplainer />
      <FounderMessage />
      <Disclaimer />
      <StartChatCta />

      <footer className="border-t border-gray-200 py-8">
        <div className="max-w-7xl mx-auto px-6 flex justify-between items-center text-sm text-gray-600">
          <span>AmiJ2株式会社 提供</span>
          <div className="flex items-center gap-4">
            <button
              type="button"
              className="text-blue-700 hover:text-blue-800 underline underline-offset-2"
              onClick={() => setPolicyOpen(true)}
            >
              プライバシーポリシー
            </button>
            <span>Powered by AmiJ2, Inc.</span>
          </div>
        </div>
      </footer>

      <PrivacyPolicyModal open={policyOpen} onClose={() => setPolicyOpen(false)} onAgree={handleAgree} />
    </div>
  );
}
